'use strict'
import angular from 'angular';

angular.module('tasksFilter').factory('TasksFilterTestOptionsProvider', function () {
    return {
        get optionsForField() {
            if (angular.element(document).find('#app').attr('data-no-fields') === '1') {
                return []
            }

            return [
                {value: 'line_item_create_date', label: 'Line Item Created Date'},
                {value: 'task_create_date', label: 'Task Creation Date'}
            ]
        },

        get optionsForComparator() {
            if (angular.element(document).find('#app').attr('data-no-comparators') === '1') {
                return []
            }

            return [
                {value: '=', label: '='},
                {value: '<', label: '<'}
            ]
        },

        get defaultFieldValue() {
            if (angular.element(document).find('#app').attr('data-with-default-filter') === '1') {
                return 'task_create_date'
            }

            return ''
        },

        get defaultComparatorValue() {
            if (angular.element(document).find('#app').attr('data-with-default-filter') === '1') {
                return '<'
            }

            return ''
        },

        defaultValues(callback) {
            let returned = {
                field: undefined,
                comparator: undefined,
                boundary: undefined
            }

            if (angular.element(document).find('#app').attr('data-with-default-filter') === '1') {
                returned.field = 'task_create_date'
                returned.comparator = '<'
                returned.boundary = 31
            }

            callback(returned)
        }
    }
})